import { render, staticRenderFns } from "./HorizontalSingleBarGraph.vue?vue&type=template&id=66fd0ec2&scoped=true"
import script from "./HorizontalSingleBarGraph.vue?vue&type=script&lang=js"
export * from "./HorizontalSingleBarGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd0ec2",
  null
  
)

export default component.exports